import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import { InputTypes } from "../../../utils/constants";
import ElementStyleProperties from "../common/elementStyleProperties";
import './elementProprtiesPanal.scss';
import Switch from "react-switch";


export interface TextAreaElementPropertiesProps {
  element: Element;
}

const TextAreaProperties: FC<TextAreaElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="container mt-3">
      <div className="form-group row">
        <label htmlFor="elementName" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Name
        </label>
        <div className="col-sm-8">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.name = e.target.value})
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="placeholder" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Placeholder
        </label>
        <div className="col-sm-8">
          <input
            type="text"
            className="form-control theam-textbox items-align-left"
            id="placeholder"
            value={element.properties.placeholder}
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.properties.placeholder = e.target.value})
              dispatch(startEditElement(newElement));
            }}
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="required-field" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Required
        </label>
        <div className="col-sm-2 mt-2">
          <Switch
            checked={element.properties.required}
            onChange={() =>{
              const newElement = produce(element, draft => {
                draft.properties.required = !draft.properties.required
              })
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="required-field"
           />
        </div>
        {/* <div className="col-sm-12">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                {element.properties.required && (
                  <div className="form-group row">
                    <label
                      htmlFor="valid-message"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Valid Feedback
                    </label>
                    <div className="col-sm-8">
                      <input
                        value={element.properties.valid_feedback}
                        className="form-control theam-textbox items-align-left"
                        onChange={(e) => {
                          const newElement = produce(element, draft => { draft.properties.valid_feedback =        e.target.value})
                          dispatch(startEditElement(newElement));
                        }}
                        type="text"
                        id="valid-message"
                      />
                    </div>
                  </div>
                )}
                {element.properties.required && (
                  <div className="form-group row">
                    <label
                      htmlFor="invalid-message"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Invalid Feedback
                    </label>
                    <div className="col-sm-8">
                      <input
                        value={element.properties.invalid_feedback}
                        className="form-control theam-textbox items-align-left"
                        onChange={(e) => {
                          const newElement = produce(element, draft => { draft.properties.invalid_feedback =        e.target.value})
                          dispatch(startEditElement(newElement));
                        }}
                        type="text"
                        id="invalid-message"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="form-group row">
        <label htmlFor="field-disabled" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Field Disable
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.disabled}
            onChange={() =>{
              const newElement = produce(element, draft => {
                draft.properties.disabled = !draft.properties.disabled
              })
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="field-disabled"
           />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <div className="form-group row">
        <label htmlFor="tooltip" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Tooltip
        </label>
        <div className="col-sm-8">
          <textarea className="form-control theam-textbox font-size-12 items-align-left" name="tooltip" id="tooltip"   placeholder="Enter tooltip" cols={30} rows={2}
            value={element.properties.tooltip}
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.properties.tooltip =   e.target.value})
                dispatch(startEditElement(newElement));
              }}
            ></textarea>
        </div>
      </div>
    </div>
  );
};

export default TextAreaProperties;
